<div class="upload-document">
  <div class="upload-document__upload-block"
    dropZone
    (fileDropped)="dropNewDocument($event)">
    <div class="upload-document__upload-inner-block">
      <i class="lf-icon-up-file common-icon__lg common-icon__main"></i>
      <div class="upload-document__upload-text-block">
        <p class="upload-document__upload-text"
          [afTranslate]="'up-document.drag-documents'">
          _Arrastra aquí tus documentos o
        </p>
        <button class="common-button__link">
          <a class="common-button__link-text"
            [afTranslate]="'record-audio-modal.discard-record'"
            (click)="openFileSearch()"
            [afTranslate]="'documentation-list.explore-pc'">
            _Explora en tu dispositivo
          </a>
        </button>
        <input class="upload-document__file-upload" id="fileDropRef"
          type="file"
          multiple
          (change)="loadFiles($event)"/>
      </div>
    </div>
  </div>
  <div class="upload-document__upload-list-items-container">
    <div class="upload-document__upload-list-container">
      <div class="upload-document__upload-list-inner-container">
        <p class="upload-document__title-text"
          [afTranslate]="'up-document.select-document'">
          _Documentos Seleccionados
        </p>
        <div class="common-badge__badge-block">
          <span class="common-badge__square-md">{{uploadDocuments.upDocuments.length}}</span>
        </div>
      </div>
    </div>
    <ul class="upload-document__upload-list-items">
      @for (document of uploadDocuments.upDocuments; track $index) {
        <li class="upload-document__upload-item-block">
          <div class="upload-document__upload-item"
            [ngClass]="{'upload-document__upload-item--error':document.status==='error' || document.status==='validate-error'}">
            <div class="upload-document__upload-item-container">
              <div [class]="(document.source | extensionDocument)+' common-icon__md'">
              </div>
              <div class="upload-document__text-container">
                <span-tooltip class="upload-document__text"
                  [text]="document.name"></span-tooltip>
                <p class="upload-document__text upload-document__text--dimension">
                  {{document.size | convertBytes}}
                </p>
              </div>
              @if(!uploadDocuments.updating){
                <div class="upload-document__container-upload-item-buttons">
                  <div class="upload-document__upload-item-buttons">
                    @if(document.status!=='error'){
                      <button class="common-button__icon-md-noborder"
                        (click)="renameDocument(document)">
                        <i class="lf-icon-rename common-icon__md"></i>
                      </button>
                    }@else {
                      <button class="common-button__icon-md-noborder"
                        (click)="addDocument(document, true)">
                        <i class="lf-icon-rotate common-icon__md"></i>
                      </button>
                    }
                    <button class="common-button__icon-md-noborder"
                      (click)="deleteDocument($index)">
                      <i class="lf-icon-trash common-icon__md"></i>
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
          @if(uploadDocuments.updating && document.progress > 0){
            <div class="common-progress-indicator__bar-block h-[4px]">
              <div class="common-progress-indicator__bar-inner"
                [ngStyle]="{'width': document.progress+'%'}">
              </div>
            </div>
          }@else if (!uploadDocuments.updating && (document.status==='error' || document.status==='validate-error')) {
            <div class="upload-document__item-block-error">
              <p class="upload-document__text upload-document__text--error">{{document.statusText}}</p>
            </div>
          }
        </li>
      }
    </ul>
  </div>
</div>
